import React from 'react';
import ValidatorSummary, { IValidatorDecisionConfig } from 'components/ValidatorSummary';
import { AsyncTaskStatus, ItemSourceMeanValidatorItemStatus as ItemStatus } from 'constants/itemSourceMeanValidatorStatus';
import ItemSourceMeanValidatorItemsModel from 'models/ItemSourceMeanValidatorItemsModel';

interface IProps {
  itemsModel: ItemSourceMeanValidatorItemsModel;
  onFilterChange: (filter: { type: 'status' | 'decision'; value: string } | null) => void;
  activeFilter: { type: 'status' | 'decision'; value: string } | null;
  onClearFilter: () => void;
}

const ItemSourceMeanValidatorSummary: React.FC<IProps> = ({ itemsModel, onFilterChange, activeFilter, onClearFilter }) => {
  const decisions: IValidatorDecisionConfig[] = [
    { key: 'exact_match', label: 'Exact Match', color: '#4CAF50' },
    { key: 'keep', label: 'Keep', color: '#66BB6A' },
    { key: 'change', label: 'Change', color: '#42A5F5' },
  ];

  const statusConfig = {
    PENDING: ItemStatus.PENDING,
    NEEDS_USER_REVIEW: ItemStatus.NEEDS_USER_REVIEW,
    DONE: ItemStatus.DONE,
  };

  const asyncTaskStatusConfig = {
    FAILED: AsyncTaskStatus.FAILED,
    DEAD_LETTER: AsyncTaskStatus.DEAD_LETTER,
  };

  // Adapter for filter change to match original signature
  const handleFilterChange = (type: string, value: string) => {
    onFilterChange({ type: type as 'status' | 'decision', value });
  };

  // Don't render anything if there are no items
  if (!itemsModel.gridData || itemsModel.gridData.length === 0) {
    return null;
  }

  return (
    <ValidatorSummary
      items={(itemsModel.gridData as any[]) || []}
      decisions={decisions}
      statusConfig={statusConfig}
      asyncTaskStatus={asyncTaskStatusConfig}
      onFilterChange={handleFilterChange}
      activeFilter={activeFilter}
      onClearFilter={onClearFilter}
      colors={{
        processing: '#9C27B0',
        review: '#FFA726',
        error: '#E53935',
      }}
    />
  );
};

export default ItemSourceMeanValidatorSummary;